export default function Testimonials() {
  const reviews = [
    {
      name: "John M.",
      text: "Fantastic quality and fast turnaround. My shirts came out perfect!",
    },
    {
      name: "Sarah P.",
      text: "Highly recommended! Excellent communication and amazing DTF prints.",
    },
    {
      name: "Pieter V.",
      text: "Best custom printing service I've used. Great prices too.",
    },
  ];

  return (
    <section className="bg-[#0b111c] py-24">
      <div className="max-w-7xl mx-auto px-6">

        <h2 className="text-5xl font-black text-center text-white">
          WHAT OUR CUSTOMERS SAY
        </h2>

        <p className="text-center text-gray-400 mt-4 mb-16">
          Trusted by customers across South Africa.
        </p>

        <div className="grid md:grid-cols-3 gap-8">

          {reviews.map((review) => (

            <div
              key={review.name}
              className="rounded-3xl border border-sky-500/20 bg-[#11192b] p-8 hover:border-sky-400 transition"
            >
              <div className="text-yellow-400 text-2xl mb-4">
                ⭐⭐⭐⭐⭐
              </div>

              <p className="text-gray-300 italic">
                "{review.text}"
              </p>

              <h3 className="mt-6 font-bold text-sky-400">
                {review.name}
              </h3>

            </div>

          ))}

        </div>

      </div>
    </section>
  );
}